import axios from 'axios';
import { action } from 'mobx';

import BaseAPIStore, { IAPIStore } from '../api.store';

export class ProductListStore extends BaseAPIStore<IProduct[]> implements IAPIStore {
  constructor() {
    super();
    this.data = [];
  }

  @action
  public async request() {
    const url = this.apiUrl + '/products';
    this.error = undefined;
    this.requesting = true;
    try {
      const response = await axios.get(url, this.authorizeConfigs());
      const responseData = response.data;
      if (responseData.data) {
        this.data = responseData.data;
      } else {
        this.error = new Error('Something went wrong.');
      }
    } catch (error) {
      this.error = error;
    }

    this.requesting = false;
  }
}

const productListStore = new ProductListStore();
export default productListStore;
